module.exports = __webpack_public_path__ + "img/introduce.a8ee32d.png";